export interface CheckInFlowData {
  checkinCompleted: boolean;
  checkins: number;
  checkinsMinors: number;
  hasPendingAdultCheckIn: boolean;
  hasPendingMinorCheckIn: boolean;
  pendingAdultCheckIn:  number;
  pendingMinorCheckIn: number;
  hasPendingAdultSignature: boolean;
  hasPendingMinorSignature: boolean;
  pendingAdultSignatureLinks: CheckInFlowSignatureLink[];
  pendingMinorSignatureLinks: CheckInFlowSignatureLink[];
  hasPendingDeposit: boolean;
  requiresCheckIn: boolean;
}


export interface CheckInFlowSignatureLink {
  travelRegisterId: string;
  contractUrl: string;
  email: string;
  name: string;
}

export function signaturePendingCheckIns(flow: CheckInFlowData) {
  return signaturePendingMinorCheckIns(flow) + signaturePendingAdultCheckIns(flow);
}

export function signaturePendingAdultCheckIns(flow: CheckInFlowData) {
  return flow.pendingAdultSignatureLinks.length;
}

export function hasSignaturePendingAdultCheckIns(flow: CheckInFlowData) {
  return signaturePendingAdultCheckIns(flow) > 0;
}

export function signaturePendingMinorCheckIns(flow: CheckInFlowData) {
  return flow.pendingMinorSignatureLinks.length;
}

export function hasSignaturePendingMinorCheckIns(flow: CheckInFlowData) {
  return signaturePendingMinorCheckIns(flow) > 0;
}

export function startedCheckIns(flow: CheckInFlowData) {
  return signaturePendingCheckIns(flow);
}

export function missingAdultCheckIns(flow: CheckInFlowData) {
  return flow.pendingAdultCheckIn - signaturePendingAdultCheckIns(flow);
}

export function hasMissingAdultCheckIns(flow: CheckInFlowData) {
  return missingAdultCheckIns(flow) > 0;
}

export function missingChildCheckIns(flow: CheckInFlowData) {
  return flow.pendingMinorCheckIn - signaturePendingMinorCheckIns(flow);
}

export function hasMissingChildCheckIns(flow: CheckInFlowData) {
  return missingChildCheckIns(flow) > 0;
}

export function missingCheckIns(flow: CheckInFlowData) {
  return missingAdultCheckIns(flow) + missingChildCheckIns(flow);
}

export function hasMissingCheckIns(flow: CheckInFlowData) {
  return missingCheckIns(flow) > 0;
}

export function hasStartedCheckIns(flow: CheckInFlowData) {
  return startedCheckIns(flow) > 0;
}

export function completedCheckIns(flow: CheckInFlowData) {
  return flow.checkins + flow.checkinsMinors;
}

export function hasCompletedAdultCheckIns(flow: CheckInFlowData) {
  return flow.checkins > 0;
}

export function pendingCheckIns(flow: CheckInFlowData) {
  return flow.pendingAdultCheckIn + flow.pendingMinorCheckIn;
}
